import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import type { MonitoringService } from "./MonitoringService";

class AppInsightsMonitoringService implements MonitoringService {
	appInsights: ApplicationInsights;

	constructor(connectionString: string) {
		this.appInsights = this.enable(connectionString);
	}

	trackError(error: string): void {
		this.appInsights.trackException({ error: new Error(error) });
	}

	trackEvent(event: string): void {
		this.appInsights.trackEvent({ name: event });
	}

	trackTrace(message: string): void {
		this.appInsights.trackTrace({ message });
	}

	enable(connectionString: string): ApplicationInsights {
		this.appInsights = new ApplicationInsights({
			config: {
				connectionString,
			}
		});

		this.appInsights.loadAppInsights();
		this.appInsights.trackPageView();

		return this.appInsights;
	}
}

export default AppInsightsMonitoringService;